import { createSelector } from 'reselect';
import { IStoreState } from '../types';
import { IComment } from '../types/comments';

// Stable reference for "no thread yet" - returning a fresh [] from the selector
// would give consumers a new array identity on every render and defeat memoing.
const EMPTY_THREAD: IComment[] = [];

export const getComments = (state: IStoreState) => state.comments;

export const getCommentCountsByImageId = createSelector(
  getComments,
  ({ countsByImageId }) => countsByImageId
);

export const getCommentsThread = createSelector(
  getComments,
  ({ threads }) =>
    (imageId: string) =>
      threads[imageId] || EMPTY_THREAD
);

/** Narrow subscription for a single tile - re-renders only when its own count moves. */
export const getCommentCountForImage = (state: IStoreState, imageId: string): number =>
  state.comments.countsByImageId[imageId] || 0;

export const getIsCommentsFetching = createSelector(getComments, ({ isFetching }) => isFetching);
